import * as React from 'react';
import type { SVGProps } from 'react';
const SvgActivate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M18.25 9.692a5.06 5.06 0 0 0-5.058-5.057H6.808a5.058 5.058 0 0 0 0 10.115h6.384a5.06 5.06 0 0 0 5.058-5.058m-5.058-3.557a3.558 3.558 0 1 1 0 7.115H6.808a3.558 3.558 0 0 1 0-7.115z"
      clipRule="evenodd"
    />
    <path d="M15.346 9.692a2.154 2.154 0 1 0-4.308 0 2.154 2.154 0 0 0 4.308 0" />
  </svg>
);
export default SvgActivate;
